import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import {
  map,
} from 'lodash';
import {
  API,
} from 'vibeguide';
import HistoryMediaItem from './HistoryMediaItem';
import './HistoryMedia.scss';

class HistoryMedia extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      history: {},
    };
  }

  componentDidMount() {
    this.getAudioHistory();
  }

  componentDidUpdate(prevProps) {
    const {
      message: {
        _id,
      },
    } = this.props;

    const {
      message: {
        _id: prevId,
      },
    } = prevProps;

    if (_id !== prevId) {
      this.getAudioHistory();
    }
  }

  /**
   * Fetch audio history
   */
  getAudioHistory = async () => {
    const {
      message: {
        _id,
        requestId,
      },
    } = this.props;

    const history = {};
    const audioHistory = await API.MessageRequest.uploadHistory(requestId || _id);

    // Group the history by day
    audioHistory.forEach((item) => {
      const itemDate = new moment(item.date);
      const day = itemDate.format('dddd, MMMM D, YYYY');

      if (!history[day]) {
        history[day] = [];
      }

      history[day].push(item);
    });

    this.setState({
      history,
    });
  };

  render() {
    const {
      history,
    } = this.state;

    return (
      <div className="HistoryMedia">
        {map(history, (items, day) => {
          return (
            <div
              key={`history-day-${day}`}
              className="history-day"
            >
              <div className="title">
                {day}
              </div>

              <div className="items">
                {items.map((item, index) => {
                  const last = (index + 1) === items.length;

                  return (
                    <HistoryMediaItem
                      key={`history-item-${index}`}
                      item={item}
                      type={item.type}
                      date={item.date}
                      url={item.url}
                      username={`${item.userFname} ${item.userLname}`.trim()}
                      imageUrl={item.userImageUrl}
                      last={last}
                    />
                  );
                })}
              </div>
            </div>
          );
        })}

        <div className="end-of-history">
          End of History
        </div>
      </div>
    );
  }
}

HistoryMedia.propTypes = {
  message: PropTypes.object.isRequired,
};

export default HistoryMedia;
